Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useThunk;

var _react = _interopRequireDefault(require("react"));

var _useIsMounted = _interopRequireDefault(require("./useIsMounted"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */
const {
  useRef
} = _react.default;
/**
 * "Middleware" hook intended to wrap `useReducer` that enables you to dispatch
 * thunks (ie. functions that dispatch actions) as well as plain actions (ie.
 * objects).
 */

function useThunk([state, dispatch]) {
  const isMounted = (0, _useIsMounted.default)(); // Use a ref to ensure our `dispatch` is stable across renders, just
  // like the React-provided `dispatch` that we're wrapping.

  const thunkDispatchRef = useRef(action => {
    if (isMounted()) {
      if (typeof action === 'function') {
        return action(payload => {
          if (isMounted()) {
            dispatch(payload);
          }
        });
      } else {
        dispatch(action);
      }
    }
  });
  return [state, thunkDispatchRef.current];
}